// extracted by mini-css-extract-plugin
export default {"tagsBox":"FeedbackTags_tagsBox__uqHbO","tags":"FeedbackTags_tags__VfUvR"};